/**
 * <ReferralShareActionsSkeleton> — la forme de `<ReferralShareActions>` pendant un chargement.
 *
 * « Partagez via » est vrai — il ne dépend de rien — et les canaux sont des pastilles à la taille
 * des boutons (`SHARE_ACTION_SIZE`) : WhatsApp, Telegram, l'e-mail.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Text } from "../../atoms/typography/Text"
import { SHARE_ACTION_SIZE } from "./ReferralShareActions"

/** Les trois canaux que l'espace parent propose. */
const CHANNELS = [0, 1, 2]

export function ReferralShareActionsSkeleton() {
    return (
        <Stack gap="2" align="center">
            <Text size="text-sm" weight="semibold" color="text-muted" center>
                Partagez via
            </Text>
            <Row justify="center" gap="2" style={styles.row}>
                {CHANNELS.map((channel) => (
                    <Skeleton key={channel} shape="circle" size={SHARE_ACTION_SIZE} />
                ))}
            </Row>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    row: { width: "100%" },
}))
